import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface SlideNavigationProps {
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
  onGoTo: (index: number) => void;
}
export function SlideNavigation({
  currentSlide,
  totalSlides,
  onNext,
  onPrev,
  onGoTo
}: SlideNavigationProps) {
  return <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-6 px-6 py-3 bg-white/80 backdrop-blur-md border border-gray-200 rounded-full shadow-lg shadow-gray-200/50" data-id="element-12">
      <button onClick={onPrev} disabled={currentSlide === 0} className="p-2 rounded-full hover:bg-gray-100 text-gray-400 hover:text-gray-900 disabled:opacity-30 disabled:hover:bg-transparent transition-colors" aria-label="Previous slide" data-id="element-13">
        <ChevronLeft className="w-5 h-5" data-id="element-14" />
      </button>

      <div className="flex items-center gap-2" data-id="element-15">
        {Array.from({
        length: totalSlides
      }).map((_, idx) => <button key={idx} onClick={() => onGoTo(idx)} className={`w-2 h-2 rounded-full transition-all duration-300 ${currentSlide === idx ? 'bg-purple-600 w-6 shadow-[0_0_10px_rgba(124,58,237,0.3)]' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-16" />)}
      </div>

      <button onClick={onNext} disabled={currentSlide === totalSlides - 1} className="p-2 rounded-full hover:bg-gray-100 text-gray-400 hover:text-gray-900 disabled:opacity-30 disabled:hover:bg-transparent transition-colors" aria-label="Next slide" data-id="element-17">
        <ChevronRight className="w-5 h-5" data-id="element-18" />
      </button>
    </div>;
}